


















import { computed, defineComponent, ref, watch, Ref } from 'vue-demi';
import { i18n } from '../../../../i18n';
import Card from '../card/index.vue';
import { useCard } from '../../hooks/use-card';
import { to } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';
import FailContent from './fail.vue';
import Loading from '../loading.vue';
import { DelayMoment } from '../../../../utils/moment';
import { CouponInfo } from '../../../../type';
import { AdInfo, CardInfo } from '../../type';

export default defineComponent({
  name: 'MallContentList',
  components: {
    Card,
    FailContent,
    Loading,
  },
  emits: ['beforeCompleted', 'afterCompleted', 'couponBtnClick'],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    const isQuerying = ref(false);
    const isQueryError = ref(false);
    const { getSpCardInfoList } = useCard();
    const cardList: Ref<Array<CardInfo & (CouponInfo | AdInfo)>> = ref([]);

    if (props.id) {
      queryData();
    }

    watch(() => props.id, (id) => {
      if (id) {
        queryData();
      }
    });

    const cardGroupList = computed(() => {
      const groupList: Array<Array<CardInfo & (CouponInfo | AdInfo)>> = [];
      const list = ([] as Array<CardInfo & (CouponInfo | AdInfo)>).concat(cardList.value);
      const itemLen = 3;
      while (list.length > itemLen) {
        groupList.push(list.splice(0, itemLen));
      }
      if (list.length) {
        groupList.push(list);
      }
      return groupList;
    });

    /** 查询商圈下券列表信息 */
    async function queryData() {
      // 券查询开始通知
      context.emit('beforeCompleted');
      const moment = new DelayMoment(800);
      isQueryError.value = false;
      isQuerying.value = true;
      cardList.value = [];
      const [err, res] = await to(getSpCardInfoList());
      if (err) {
        isQueryError.value = true;
        new CustomException(err, 'querySpCouponDataErr');
      } else {
        cardList.value = res || [];
      }
      await moment.done();
      isQuerying.value = false;
      // 券查询完毕通知
      context.emit('afterCompleted', props.id);
    }

    function handleRetry() {
      queryData();
    }

    return {
      i18n,
      isQueryError,
      isQuerying,
      cardGroupList,
      handleRetry,
    };
  },
});
